var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2734 4.00781C12.4883 4.95703 11.1758 5.66016 10.1328 5.66016C10.0039 5.66016 9.88672 5.63672 9.81641 5.625C9.80469 5.56641 9.76953 5.39062 9.76953 5.20312C9.76953 4.00781 10.3789 2.8125 11.0469 2.0625C11.8789 1.07812 13.2852 0.351562 14.457 0.304688C14.4805 0.433594 14.4922 0.597656 14.4922 0.761719C14.4922 1.95703 13.9883 3.14062 13.2734 4.00781ZM14.0938 5.90625C14.75 5.90625 17.1289 5.97656 18.6875 8.21484C18.5469 8.32031 16.1914 9.65625 16.1914 12.6328C16.1914 16.0664 19.1914 17.2969 19.2852 17.3203C19.2734 17.4023 18.8047 18.9844 17.7031 20.6133C16.707 22.0312 15.6641 23.4727 14.0938 23.4727C12.5117 23.4727 12.1016 22.5469 10.2969 22.5469C8.51562 22.5469 7.88281 23.4961 6.45312 23.4961C5 23.4961 3.99219 22.1719 2.84375 20.5547C1.49609 18.6445 0.417969 15.6797 0.417969 12.8672C0.417969 8.36719 3.34766 5.97656 6.24219 5.97656C7.76562 5.97656 9.03125 6.97266 10.0039 6.97266C10.918 6.97266 12.3477 5.90625 14.0938 5.90625Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.02968de7437ec53229679f49e777be90.svg";
export { ForwardRef as ReactComponent };